export default {
    data: () => ({
        auditStockOrderColumns: [
            {
                label: "order",
                field: "id",
                sortable: true,
                required: true
            },
            {
                label: "order status",
                field: "stock_order_status.description",
                sortable: true,
                required: true,
            },
            {
                label: "stock operation",
                field: "stock_operation.description",
                sortable: true,
                required: true,
                hide: true
            },

            {
                label: "id POS",
                field: "lending_point_id_requester",
                sortable: true,
                required: true
            },
            {
                label: "POS",
                field: "lending_point_requester.description",
                sortable: true,
                required: true
            },
            {
                label: "quantity",
                field: "quantity",
                sortable: true,
                required: true
            },
            {
                label: "order date",
                field: "created_at",
                sortable: true,
                required: true
            },
            {
                label: "contact",
                field: "lending_point_requester.phone",
                sortable: true,
                required: true
            },
            {
                label: "address",
                field: "lending_point_requester.full_address",
                sortable: true,
                required: true
            }
        ]
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/auditStockOrderColumns.js